import type { PslfFormExtension as PslfFormModel } from 'tio-data/data/resources/pslf-form.ext';
import Component from '@glimmer/component';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import type { IntlService } from 'ember-intl';
import { Section, VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';

interface AdminPslfFormSuccessRouteSignature {
  Args: {
    model: PslfFormModel;
  };
}
export default class AdminPslfFormSuccessRoute extends Component<AdminPslfFormSuccessRouteSignature> {
  @service declare intl: IntlService;
  @service declare router: RouterService;

  get borrowerName() {
    return this.args.model.borrowerFields['borrower-name'];
  }

  get dateEmployerSigned() {
    const dateSigned = this.args.model.employerCompletedAt;
    return dateSigned ? dateSigned : new Date();
  }

  get employerMessage() {
    return this.intl.t('pslf.complete_pslf.done_employer_subheader', {
      date: this.intl.formatDate(this.dateEmployerSigned),
      name: this.borrowerName,
    });
  }

  <template>
    <VStack>
      <PageHeader
        @title={{t "pslf.complete_pslf.title_success"}}
        @subtitle={{t "pslf.default_full"}}
        @sticky={{false}}
      />
      <Section>
        {{#if this.dateEmployerSigned}}
          <div class="p-4">
            <p class="text-lg my-4">{{this.employerMessage}}.</p>
            <p class="text-lg">{{t "pslf.complete_pslf.done_employer"}}</p>
          </div>
        {{/if}}
      </Section>
    </VStack>
  </template>
}
